module.exports = __webpack_public_path__ + "static/media/dropdown.5873abda.svg";